import React from 'react';
import MobileRolesApp from '../Functionality/MobileRolesApp';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../components/CustomTab';
import ModuleCard from './ModuleItem';
import CustomTable from '../../../../../components/table/CustomTable';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const MobileRoles = (props) => {
    const { mobile, selectedPermissions = [], setSelectedPermissions, readOnly } = props;
    const {
        t,
        roles,
        selectedInnerView,
        handleStepSelectedInnerView,
        selectedRole,
        thead,
        tbody,
        selectedRoleCount,
        getSelectedCount,
        isAllChecked,
        handleSelectAll,
    } = MobileRolesApp({ mobile, selectedPermissions, setSelectedPermissions, readOnly });

    return (
        <div>
            <div className='row'>
                <div className='col-12 px-0'>
                    <CustomTabContainer
                        activeTab={selectedInnerView}
                        setActiveTab={handleStepSelectedInnerView}
                        className='rounded-top border-0 px-3'
                    >
                        {(roles || []).map((role) => {
                            const Icon = role.icon;

                            return (
                                <CustomTab
                                    key={role.id}
                                    id={role.id}
                                    title={t(role.translation)}
                                    icon={<Icon className='h-24px w-24px icon-color-general-950' />}
                                    newsNumber={getSelectedCount(role)}
                                    selected={selectedInnerView === role.id}
                                    onClick={() => handleStepSelectedInnerView(role.id)}
                                />
                            );
                        })}
                    </CustomTabContainer>
                </div>

                {selectedRole && (
                    <div className='col-12 col-sm-6 col-lg-4 mt-4'>
                        <ModuleCard
                            icon={selectedRole.icon}
                            title={selectedRole.translation}
                            t={t}
                            count={selectedRoleCount}
                        />
                    </div>
                )}
                <div className='mt-4'>
                    <CustomCheckbox
                        trans={t('de_/_select_all').toUpperCase()}
                        checked={isAllChecked}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        disabled={readOnly}
                    />
                </div>
                <div className={'col-12 p-0'}>
                    <div className='overflow-auto'>
                        <CustomTable
                            tableId='tbl_mr_table_roles'
                            searchId='tbl_mr_search_id'
                            thead={thead}
                            tbody={tbody}
                            checkbox={false}
                            columnActions={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileRoles;
